<template>
  <div class="col-md-4 !tw-mx-auto login-wrapper blocked-account">
    <div class="login-logo">
      <img
        :src="logo"
        alt="logo"
      >
    </div>

    <form>
      <Card class="card-login">
        <i class="fas fa-exclamation-triangle !tw-flex !tw-justify-center" />
        <h3>
          {{ $t('forms.blockedAccount.yourAccount') }}
          <br>
          {{ $t('forms.blockedAccount.isBlocked') }}
        </h3>
        <div class="row">
          <div class="col-12 blocked-account__text">
            {{ $t('forms.blockedAccount.blockedAccountText') }}.
          </div>
        </div>
        <div class="btn-box !tw-flex !tw-justify-between">
          <button
            class="btn btn-outline-primary btn-md"
            @click="$router.push('/logout')"
          >
            &lt; {{ $t('forms.btn.back') }}
          </button>
          <a
            class="btn btn-primary btn-md"
            :href="contactsUrl"
            target="_blank"
          >
            {{ $t('forms.btn.contactUs') }}
          </a>
        </div>
      </Card>
    </form>
  </div>
</template>

<script>
import _ from '@/lib/lodash';

export default {
  computed: {
    logo() {
      return this.$config.layout.logoFull;
    },
    contactsUrl() {
      const defaultUrl = `https://${this.$config.frontPageUrl}/contact-us`;
      return _.get(this.$store.state, 'misc.miscSettings.contacts.contact_us_form', defaultUrl);
    },
  },
};
</script>
